var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9307 1.56487C12.6898 2.32392 12.6898 3.55459 11.9307 4.31365L3.90126 12.3431C3.8008 12.4436 3.66454 12.5 3.52246 12.5H0.535714C0.239847 12.5 0 12.2602 0 11.9643V8.97754C0 8.83546 0.0564412 8.6992 0.156907 8.59874L8.18635 0.56929C8.94541 -0.189763 10.1761 -0.189763 10.9351 0.56929L11.9307 1.56487ZM11.1731 3.55603C11.5137 3.2154 11.5137 2.66312 11.1731 2.32249L10.1775 1.3269C9.83688 0.98627 9.2846 0.98627 8.94397 1.3269L7.47907 2.79181L9.70819 5.02093L11.1731 3.55603ZM8.95058 5.77855L6.72145 3.54942L1.07143 9.19944V11.4286H3.30056L8.95058 5.77855Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditColor);
export default __webpack_public_path__ + "static/media/editColor.71a8489a977c570cc4d86822874f7bac.svg";
export { ForwardRef as ReactComponent };